
























import Vue from 'vue';
import moment from 'moment';
import { getContentArea } from '@/contentful';

interface Data {
  copyright: string;
  year: string;
  links: any;
  clientName: string;
}

export default Vue.extend({
  name: 'FooterSecondary',
  props: {
    publicLinks: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  beforeMount() {
    getContentArea([
      'footer-information',
      'footer-link-non-discrimination',
      'footer-link-legal-terms-of-use',
      'footer-link-privacy-policy',
      'footer-link-security-policy',
    ]).then((data) => {
      const contentAreas = data;
      if (contentAreas) {
        if (contentAreas[0] && contentAreas[0].fields) {
          this.copyright = contentAreas[0].fields.copyright;
        }
        if (contentAreas[1] && contentAreas[1].fields) {
          this.links.nonDiscrimination = this.getLinkInfo(
            contentAreas[1].fields,
          );
          this.links.nonDiscrimination.text = [
            'footer_link_non-discrimination',
            'global_non-discrimination',
          ];
          if (this.publicLinks) {
            this.links.nonDiscrimination.value = `${this.getPublicSiteRoot()}${this.$options.filters.t('footer-public-link-nondiscrimination')}`;
          }
        }
        if (contentAreas[2] && contentAreas[2].fields) {
          this.links.legalTermsOfUse = this.getLinkInfo(contentAreas[2].fields);
          this.links.legalTermsOfUse.text = [
            'footer_link_legal-terms-of-use',
            'global_legal-terms-of-use',
          ];
          if (this.publicLinks) {
            this.links.legalTermsOfUse.value = `${this.getPublicSiteRoot()}${this.$options.filters.t('footer-public-link-legal-terms')}`;
          }
        }
        if (contentAreas[3] && contentAreas[3].fields) {
          this.links.privacyPolicy = this.getLinkInfo(contentAreas[3].fields);
          this.links.privacyPolicy.text = [
            'footer_link_privacy-policy',
            'global_privacy-policy',
          ];
          if (this.publicLinks) {
            this.links.privacyPolicy.value = `${this.getPublicSiteRoot()}${this.$options.filters.t('footer-public-link-privacy')}`;
          }
        }
        if (contentAreas[4] && contentAreas[4].fields) {
          this.links.securityPolicy = this.getLinkInfo(contentAreas[4].fields);
          this.links.securityPolicy.text = [
            'footer_link_security-policy',
            'global_security-policy',
          ];
          if (this.publicLinks) {
            this.links.securityPolicy.value = `${this.getPublicSiteRoot()}${this.$options.filters.t('footer-public-link-security')}`;
          }
        }
      }
    });
  },
  data(): Data {
    return {
      copyright: '',
      year: moment().format('Y'),
      links: {},
      clientName: process.env.VUE_APP_CLIENT_NAME,
    };
  },
  methods: {
    getLinkInfo(val): any {
      let regex;
      const link = val.actionValue;
      const config = {
        type: '',
        value: '',
        hidden: val.hidden || false,
      };
      if (this.publicLinks) {
        config.type = 'link';
        return config;
      }
      if (link.indexOf('route="') > -1) {
        config.type = 'route';
        regex = /(route=")(.*)(")/g;
      } else if (link.indexOf('link="') > -1) {
        config.type = 'link';
        regex = /(link=")(.*)(")/g;
      } else if (link.indexOf('link:self="') > -1) {
        config.type = 'self';
        regex = /(link:self=")(.*)(")/g;
      }
      config.value = link.replace(regex, (match, a, b) => {
        return b;
      });
      return config;
    },
    getPublicSiteRoot(): string {
      if (process.env.VUE_APP_HOMEPAGE_URL) {
        return process.env.VUE_APP_HOMEPAGE_URL;
      }
      return this.$options.filters.t('login_home-url') + '/';
    },
    contactUsLink(): string {
      return this.clientName === 'Vermont' ?
      this.$options.filters.t('footer-public-link-vermont-contact') :
      `${this.getPublicSiteRoot()}${this.$options.filters.t('footer-public-link-contact')}`;
    },
  },
});
